export const getUserFirstAndLastName = (user: {
  person: { first_name: string; last_name: string };
}): string => {
  if (!user) return "";
  return `${user.person.first_name} ${user.person.last_name}`;
};
